/**
 * Получаем период для запроса начислений в формате 201101
 *
 * @returns {Object}
 */

export default () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const previusDate = new Date(new Date().setMonth(currentMonth - 1));
  const previusMonth = previusDate.getMonth();
  const previusYear = previusDate.getFullYear();
  return {
    date_from: String(previusYear) + String(previusMonth + 1).padStart(2, '0'),
    date_to: String(currentYear) + String(currentMonth + 1).padStart(2, '0'),
  };
};
